import React, { Component } from 'react';

const ALBUM_ART_URL = 'https://dxdgspd1vze29.cloudfront.net/small/';
const DEFAULT_ALBUM_ART = 'https://dxdgspd1vze29.cloudfront.net/default-album-art.png';

class AlbumArt extends Component {

  constructor(props){
    super(props);

    this.state = { 
        albumArtUrl: this.albumArtUrl() 
    };

    this.handleError = this.handleError.bind(this);
  }

  componentDidUpdate(props){
    if(props.album !== this.props.album){
      this.setState({
          albumArtUrl: this.albumArtUrl()
      });
    }
  }

  handleError(){
    this.setState({
        albumArtUrl: DEFAULT_ALBUM_ART
    });
  }

  albumArtUrl() {
    if(this.props.album !== null){
        var album = this.props.album.trim();
        album = album.replace(/ /g, '_');
        return ALBUM_ART_URL + album + '.gif'
    }
  }

  render() {
    return (
      <div className="AlbumArt">
        <img className="img-rounded img-responsive"
            onError={ this.handleError }
            src={ this.state.albumArtUrl }
            alt={ this.props.album } />
      </div>
    );
  }
}

export default AlbumArt;



// WEBPACK FOOTER //
// ./src/AlbumArt.js